import { render, staticRenderFns } from "./BankIframePopup.vue?vue&type=template&id=0ea6472c&scoped=true"
import script from "./BankIframePopup.vue?vue&type=script&lang=ts"
export * from "./BankIframePopup.vue?vue&type=script&lang=ts"
import style0 from "./BankIframePopup.vue?vue&type=style&index=0&id=0ea6472c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea6472c",
  null
  
)

export default component.exports